<button data-cy="button" matIconButton class="mat-primary" [type]="type()" [title]="title()" [disabled]="disabled()">
  <ng-content></ng-content>
</button>
